import { useContext, useEffect } from "react";
import { AppContext } from "../../contexts/AppContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { RouteContext } from "../../contexts/RoutesContext";
import { Colour } from "../Variables";
import { PersonalDetailsForm } from "../components/Forms/PersonalDetailsForm";

export function PersonalDetails() {
    const app = useContext(AppContext);
    const routeContext = useContext(RouteContext);
    useEffect(() => {
        routeContext.setRoutes([{ name: "Personal details", route: null }])
    }, []);

    return (
        <>
            <InfoBanner
                header="Personal details"
                narrow={true}
                icon={InfoHeaderIcon.PersonalDetails}
                info={`Please provide accurate personal details. ${app.firmName} will use these to contact you.`}
                subHeader={`${app.firmName} Online Application System`}
                theme={Colour.White}>
            </InfoBanner>

            <PersonalDetailsForm />
        </>
    );
}